import { Injectable } from '@angular/core';
import Dexie from 'dexie';
declare var $: any;

@Injectable({
  providedIn: 'root'
})

export class ProyectService {
  titulo: string;

  constructor() {
    this.titulo = 'Inicio';
  }

  Changetitulo(message) {
    this.titulo = message;
  }

  async existeSession(){
    return await Dexie.exists('EstacionesTVA');
  }
}
